import type { FC } from 'react'
import { useState } from 'react'

import { StyledText } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'
import Tabs from '@/components/Tabs'

import { ProductInfoTab } from './ProductInfo'
import { ProductSettingsTab } from './ProductSettings'

export type ProductMoreInfoProps = {
  policyId: number
  productId: number
  isSelected?: boolean
}

const TABS_LIST = [
  { value: 'settings', label: <Translation id="Product Settings" /> },
  { value: 'general', label: <Translation id="General" /> },
]
export const ProductMoreInfoOverview: FC<
  ProductMoreInfoProps & { isGroupedProduct?: boolean; onClose: () => void }
> = ({ isSelected, policyId, productId, isGroupedProduct = false, onClose }) => {
  const [tabValue, setTabValue] = useState(isSelected ? TABS_LIST[0].value : TABS_LIST[1].value)
  const filteredTabs = isSelected ? TABS_LIST : TABS_LIST.filter(tab => tab.value !== 'settings')

  return (
    <>
      {isSelected ? (
        <Tabs
          selectedValue={tabValue}
          tabs={filteredTabs}
          onClick={tabId => {
            setTabValue(String(tabId))
          }}
        />
      ) : (
        <StyledText size="xl" fontWeight="bold" colorMode="black">
          <Translation id="Product information" />
        </StyledText>
      )}
      {isSelected && tabValue === 'settings' && (
        <ProductSettingsTab
          policyId={policyId}
          productId={productId}
          isGroupedProduct={isGroupedProduct}
          onClose={onClose}
        />
      )}
      {tabValue === 'general' && (
        <ProductInfoTab
          isSelected={isSelected}
          policyId={policyId}
          productId={productId}
          isGroupedProduct={isGroupedProduct}
          onClose={onClose}
        />
      )}
    </>
  )
}
